import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { EcommerceService } from 'src/app/service/ecommerce.service';
import { CartService } from '../cart.service';
@Component({
   selector : 'app-check-out',
   templateUrl : './check-out.component.html',
   styleUrls : ['./check-out.component.css']
})
export class CheckOutComponent implements OnInit{
   total : number = 0;
   cartData : any = [];
   alertMsg = false;
   productLength : any;
   model : any = {
      firstName : '',
      lastName : '',
      userName : '',
      email : '',
      address : '',
      address2 : '',
      country : '',
      state : '',
      zip : ''  
   }
   cartDataTotalCount : number = 0;
   TotalAllDetails : any = []; 
   last :any=[];
   constructor( private cartService : CartService, private ecommerceService : EcommerceService){}
   ngOnInit(){
      this.cartData = this.cartService.checkOutCartData;
      this.onTotal();
      this.cartDataCount();
   }

   onTotal(){
      let totalAmout = 0;
      for (let i = 0; i < this.cartData.length; i++) {
         totalAmout += this.cartData[i].subTotal;
         }
      this.total = totalAmout;
      this.cartDataTotalCount = this.cartData.length;
   }

   onClose(){
      this.alertMsg = false;
   }

   onSubmit(formData : NgForm){
      // console.log(formData.value);
      // console.log(this.cartData);
      // console.log(this.total);

      if(this.cartData.length == 0){
         formData.reset();
         this.alertMsg = true;
      }

      else{
      this.alertMsg = false;
      this.TotalAllDetails.push(formData.value,this.cartData,this.total)
      // this.last =this.TotalAllDetails;
      // console.log(this.last);
      let customerValue = {
         'formData': formData.value,
         'cartData': this.cartData,
         'total': this.total
      }
       this.last.push(customerValue);
       
      localStorage.setItem('TotalAllDetails', JSON.stringify(this.last));
      this.checkOutSubmit(this.last);
      localStorage.clear();
      //this.TotalAllDetails = [];
      //this.last = [];
      this.cartData = [];
      this.cartDataTotalCount = 0;
     // this.cartService.checkOutCartData = [];
   //   this.ecommerceService.cartDatas = [];
   //   this.ecommerceService.addToCartData = [];
     this.ecommerceService.productCart = [];
      this.total = 0;
       formData.reset();
      }

      this.productLength = 0;

   }

   cartDataCount() {
      this.ecommerceService.cartDatas = this.ecommerceService.showToCard();
      this.productLength = this.ecommerceService.cartDatas.length;
      console.log('rafeeq', this.ecommerceService.cartDatas);
   }


      checkOutSubmit(val : any){
         this.cartService.sendData(val);
      }

   }
